export default __webpack_public_path__ + "1d62a918b216617d03122de74523b0e5.webp";